import script from "./FootCom.vue?vue&type=script&lang=ts&setup=true"
export * from "./FootCom.vue?vue&type=script&lang=ts&setup=true"

import "./FootCom.vue?vue&type=style&index=0&id=2490ce9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2490ce9a"]])

export default __exports__